module.exports = __webpack_public_path__ + "static/media/angle-left.3cf2fad1.svg";